// Scheduled messages (30-Oct-2026): the listing card with the messages sent automatically
// to each booking. Panel: components/Propiedades/ScheduledMessagesPanel.vue
export const scheduledMessages = {
  head: {
    title: "Scheduled messages",
    sub: "What the guest receives, from booking until after they leave.",
    new: "New message",
  },
  loadError: "The messages could not be loaded.",
  retry: "Try again",
  cancel: "Cancel",
  noName: "Untitled",
  tabs: { mensajes: "Messages", proximos: "Upcoming sends", historial: "History" },
  stages: { antes: "Before arrival", durante: "During the stay", despues: "After departure" },
  when: {
    entrada: "check-in",
    salida: "check-out",
    sameDay: "On the day of {momento}, at {hora}",
    before: "{n} day before {momento}, at {hora} | {n} days before {momento}, at {hora}",
    after: "{n} day after {momento}, at {hora} | {n} days after {momento}, at {hora}",
  },
  channels: { email: "Email", whatsapp: "WhatsApp", ota: "OTA" },
  origins: { all: "All", directa: "Direct", booking: "Booking", airbnb: "Airbnb", expedia: "Expedia", otras: "Other channels" },
  status: {
    pendiente: "In progress",
    enviado: "Sent",
    en_cola: "Waiting for acceptance",
    fallo: "Not sent",
    sin_contacto: "No contact details",
    cancelado: "Cancelled",
  },
  errors: {
    canal_reserva_no_encontrada: "The channel couldn't find this booking. It may no longer exist or its chat may be unavailable.",
    canal_sin_permiso: "The channel didn't authorize the message. Check this property's connection.",
    canal_no_responde: "The channel didn't respond at that moment.",
    canal_rechazo: "The channel didn't accept the message.",
    whatsapp_numero_invalido: "The number isn't valid or doesn't have WhatsApp.",
    whatsapp_rechazo: "WhatsApp didn't accept the message.",
    correo_fallido: "The email couldn't be delivered.",
    envio_fallido: "The message couldn't be sent.",
    envio_interrumpido: "Sending was interrupted before it finished.",
    sin_telefono: "The booking has no valid phone number.",
    sin_correo: "The booking has no email of its own. OTA emails are aliases.",
    sin_chat_ota: "The booking doesn't come from an OTA with chat.",
    mensaje_borrado: "The message was deleted before sending.",
    mensaje_desactivado: "The message was turned off before sending.",
    reserva_cancelada: "The booking was cancelled before sending.",
    alojamiento_no_existe: "The property no longer exists.",
    mensaje_vacio: "The message ended up empty.",
    ya_no_tocaba: "By the time the guest accepted, it was no longer due.",
  },
  unitScope: {
    sub: "Only for {name}. Listing messages reach it too, unless you change or turn them off here.",
    inherited: "From the listing",
    replaces: "Replaces the listing's",
    removed: "Off for this unit",
    offInListing: "Off in the listing",
    differentIn: "Different in: {names}",
    customize: "Change for this unit only",
    turnOff: "Don't send “{name}” for this unit",
    confirmRestore: "Delete? The listing's message will apply again.",
    ownUnits: "These units also have their own messages: {names}. Edit them from each unit.",
    replaceHint: "Same name as a listing message: this one will go out instead for this unit.",
  },
  clone: {
    button: "Clone",
    rowAction: "Clone to another property or unit",
    titleAll: "Clone to other properties or units",
    bring: "Bring from another",
    bringTitle: "Bring messages from another property or unit",
    bringNoun: "its scheduled messages",
    titleOne: "Clone “{name}”",
    subtitle: "The text, channels, filters and files are copied. A message with the same name there is updated; the others are left alone. Active messages will start sending at each property's local time.",
    nounAll: "the scheduled message | the {n} scheduled messages",
    nounOne: "the message “{name}”",
    done: "Copied to {n} property: {nuevos} new and {actualizados} updated. | Copied to {n} properties: {nuevos} new and {actualizados} updated.",
    skipped: {
      limite: "{names}: already has the maximum number of messages, so “{msgs}” did not fit.",
      archivo: "{names}: a file from “{msgs}” is missing. Upload it again here and clone once more.",
      error: "{names}: “{msgs}” could not be copied.",
    },
  },
  timeline: {
    booked: "Booking confirmed",
    bookedHint: "If they book after a moment has passed, that message isn't sent.",
    checkin: "Check-in day",
    checkout: "Check-out day",
    use: "Use",
    add: "+ Add a message here",
    offset: {
      sameDay: "That day",
      before: "{n} day before | {n} days before",
      afterCheckin: "{n} day after | {n} days after",
      beforeCheckout: "{n} day before leaving | {n} days before leaving",
      after: "{n} day after | {n} days after",
    },
  },
  presets: {
    week: { name: "One week to go", text: "Hi {nombre}, your stay at {alojamiento} is almost here. We look forward to welcoming you on {entrada}. If you need anything before you arrive, just message us." },
    three: { name: "Get ready for your arrival", text: "Hi {nombre}, in 3 days we welcome you to {alojamiento}. Check-in is from {hora_entrada}. Here is everything about your stay: {enlace_portal}" },
    arrival: { name: "Today is your arrival", text: "Hi {nombre}, we expect you today at {alojamiento} from {hora_entrada}. Safe travels!" },
    firstNight: { name: "First night", text: "Hi {nombre}, we hope you have settled in at {alojamiento}. Is everything fine? If you need anything, just reply to this message." },
    lastDay: { name: "Check-out day", text: "Hi {nombre}, your stay at {alojamiento} ends today. Please remember that check-out is until {hora_salida}. Thank you for staying with us." },
    after: { name: "Thanks for visiting", text: "Hi {nombre}, thank you for staying at {alojamiento}. We hope to see you again soon." },
  },
  row: {
    files: "{n} file | {n} files",
    sent: "{n} sent | {n} sent",
    queued: "{n} waiting",
    failed: "{n} not sent",
    duplicate: "Duplicate",
    delete: "Delete",
    confirmDelete: "Delete this message?",
    yesDelete: "Yes, delete",
    copyOf: "Copy of {name}",
  },
  upcoming: {
    arrives: "Arrives {fecha}",
    leaves: "Leaves {fecha}",
    note: "What will go out in the next 30 days with today's bookings. Crossed out: that booking cannot be reached through that channel.",
    empty: "No sends are scheduled for the next 30 days.",
    when: "When",
    guest: "Guest",
    message: "Message",
    channels: "Channels",
    needsCheckin: "Only if they complete check-in",
    noReach: "No data for this channel",
  },
  history: {
    empty: "No message has been sent yet.",
    when: "Date",
    result: "Result",
    prev: "Previous",
    next: "Next",
  },
  vars: {
    nombre: "Name",
    alojamiento: "Accommodation",
    entrada: "Check-in date",
    salida: "Check-out date",
    hora_entrada: "Check-in time",
    hora_salida: "Check-out time",
    codigo: "Booking code",
    enlace_portal: "Portal link",
    enlace_tienda: "Store link",
  },
  form: {
    newTitle: "New message",
    editTitle: "Edit message",
    name: "Internal name",
    namePh: "E.g.: Get ready for your arrival",
    when: "When it is sent",
    type: { antes: "Before", dia: "On the same day as", despues: "After" },
    days: "Days",
    reference: "Reference",
    theDayOf: "Day of",
    anchor: { entrada: "Check-in", salida: "Check-out" },
    time: "Time",
    timeIn: "{zone} time",
    timeEach: "at each property's local time: {zones}",
    noZone: "{names}: without a country we don't know its time, so messages won't go out there. Set it in the property's location.",
    localTime: "accommodation time",
    duringHint: "If the stay is shorter and the guest is no longer there that day, it is not sent.",
    channels: "How it is sent",
    channelShort: { email: "Own email only", whatsapp: "Template after 24 h", ota: "Booking chat" },
    previewShort: "Preview",
    previewFrom: "Message from",
    channelHint: {
      email: "Only for bookings with their own email. The email OTAs provide is an alias, so nothing is delivered there.",
      whatsapp: "If more than 24 h have passed or there is no conversation, we send the contact template and the message reaches the guest once they accept it. Nothing is sent to a fake number.",
      ota: "Through the OTA chat, only for bookings from that channel. Files are sent as a link.",
    },
    bookings: "Which bookings",
    onlyCheckin: "Only if they have already completed check-in",
    message: "Message",
    messagePh: "Write the message the guest will receive",
    translate: "Translate into the other languages",
    translating: "Translating…",
    translated: "Translated into the other languages.",
    translatePartial: "{n} languages could not be translated. Please review them.",
    storeHint: "The in-house store needs a completed check-in; until then, the link goes to the guest portal, which leads to it. With an external store, it goes straight there.",
    fallbackHint: "It is sent in the guest's language. If that language has no text, it goes in Spanish or the first one available.",
    subject: "Email subject (optional)",
    subjectPh: "If left empty: Message from your accommodation",
    files: "Photos, videos and documents",
    addFile: "Add file",
    uploading: "Uploading…",
    filesHint: "JPG or PNG photos up to {img} MB, PDF up to {pdf} MB, XML up to {xml} MB and MP4 or 3GP (H.264) videos up to {video} MB. WhatsApp doesn't accept XML as a file, so it goes as a link there. By email it's attached.",
    fileTooBig: "\"{name}\" exceeds the {max} MB limit.",
    uploadError: "The file could not be uploaded.",
    active: "Active",
    inactive: "Inactive",
    save: "Save",
    saving: "Saving…",
    saved: "Message saved.",
    saveError: "Could not save. Please try again.",
    errName: "Give the message a name.",
    errChannels: "Choose at least one sending channel.",
    errTime: "Enter the sending time.",
    errText: "Write the message in at least one language.",
    preview: "Preview with sample data",
    previewEmpty: "The message will appear here.",
  },
};
